import {
  FETCH_TOP_KEYWORDS_OVERVIEW_IN_PROGRESS,
  FETCH_TOP_KEYWORDS_OVERVIEW_SUCCESSFUL,
  FETCH_TOP_KEYWORDS_OVERVIEW_FAILED,
  FETCH_TOP_KEYWORDS_IN_PROGRESS,
  FETCH_TOP_KEYWORDS_SUCCESSFUL,
  FETCH_TOP_KEYWORDS_FAILED,
  FETCH_TOP_KEYWORDS_FOR_DASHBOARD_IN_PROGRESS,
  FETCH_TOP_KEYWORDS_FOR_DASHBOARD_FINISHED
} from "./types";

export const fetchTopKeywordsOverviewInProgress = (guid, seo_db) => ({
  type: FETCH_TOP_KEYWORDS_OVERVIEW_IN_PROGRESS,
  guid: guid,
  seo_db: seo_db
});

export const fetchTopKeywordsOverviewSuccessful = (guid, seo_db, overview) => ({
  type: FETCH_TOP_KEYWORDS_OVERVIEW_SUCCESSFUL,
  guid: guid,
  seo_db: seo_db,
  overview: overview
});

export const fetchTopKeywordsOverviewFailed = (guid, seo_db) => ({
  type: FETCH_TOP_KEYWORDS_OVERVIEW_FAILED,
  guid: guid,
  seo_db: seo_db
});

export const fetchTopKeywordsInProgress = (guid, seo_db, order_by, order_dir) => ({
  type: FETCH_TOP_KEYWORDS_IN_PROGRESS,
  guid: guid,
  seo_db: seo_db,
  order_by: order_by,
  order_dir: order_dir
});

export const fetchTopKeywordsSuccessful = (guid, seo_db, order_by, order_dir, keywords, has_more) => ({
  type: FETCH_TOP_KEYWORDS_SUCCESSFUL,
  guid: guid,
  seo_db: seo_db,
  order_by: order_by,
  order_dir: order_dir,
  keywords: keywords,
  has_more: has_more
});

export const fetchTopKeywordsFailed = (guid, seo_db, order_by, order_dir) => ({
  type: FETCH_TOP_KEYWORDS_FAILED,
  guid: guid,
  seo_db: seo_db,
  order_by: order_by,
  order_dir: order_dir
});

export const fetchTopKeywordsForDashboardInProgress = (domain, seoDb) => ({
  type: FETCH_TOP_KEYWORDS_FOR_DASHBOARD_IN_PROGRESS,
  domain,
  seoDb
});

export const fetchTopKeywordsForDashboardFinished = (domain, seoDb) => ({
  type: FETCH_TOP_KEYWORDS_FOR_DASHBOARD_FINISHED,
  domain,
  seoDb
});
